import Http from "./base-http";

class UserPosition extends Http {
  addUserPosition(variables) {
    return this.create(variables);
  }
  deleteUserPosition(id) {
    return this.destroy(id);
  }
}
const userPosition = new UserPosition({
  modelUrlPrefix : "UserPosition"
});
export default userPosition;